import axiosInstance from "../../../api/axiosInstance";
import { buildFisHTML } from "./HesapIslemFisHTMLBuilder";

import {
  shouldUseBluetoothPrint,
  isBluetoothPrinterConnected,
  connectBluetoothPrinter,
  printBluetoothFis,
  printHtmlFallback,
} from "./BluetoothEscPosService";

/* ===========================================================
   FİŞ YAZDIR — SEÇİLİ İŞLEMLER

   YENİ ÇALIŞMA MANTIĞI
   -----------------------------------------------------------

   PC / MASAÜSTÜ:

   Backend
      ↓
   Fiş modeli
      ↓
   HesapIslemFisHTMLBuilder.js
      ↓
   HTML
      ↓
   Browser Print


   MOBİL / iOS BLUEFY / ANDROID WEB BLUETOOTH:

   Kullanıcı "Fiş Yazdır" butonuna basar
      ↓
   Bluetooth cihaz seçimi
      ↓
   Backend fiş verisi
      ↓
   Aynı fis modeli hazırlanır
      ↓
   printBluetoothFis()
      ↓
   buildEscPosFis()
      ↓
   DOĞRUDAN ESC/POS TEXT
      ↓
   BLE GATT
      ↓
   Termal Yazıcı


   ÖNEMLİ:

   Mobil Bluetooth baskısında artık:

   HTML
      ↓
   SVG
      ↓
   Canvas
      ↓
   Raster

   zinciri kullanılmaz.

   Bu özellikle iOS / Bluefy tarafında daha basit ve
   daha güvenilir Bluetooth aktarımı sağlar.

   PC tarafındaki HTML fiş tasarımı değişmez.
=========================================================== */

export const printSelectedFis = async ({
  selectedRows,
  rows,
  bakiyeTL,
  bakiyeUSD,
  bakiyeEUR,
  bakiyeGram,
}) => {
  /* ===========================================================
     1) TEMEL KONTROLLER
  =========================================================== */

  if (
    !Array.isArray(selectedRows) ||
    selectedRows.length === 0
  ) {
    alert(
      "Lütfen fiş için en az bir işlem seçiniz."
    );

    return;
  }

  if (!Array.isArray(rows)) {
    alert(
      "İşlem listesi bulunamadı."
    );

    return;
  }

  /* ===========================================================
     2) MOBİL + WEB BLUETOOTH KONTROLÜ
  =========================================================== */

  const bluetoothPrint =
    shouldUseBluetoothPrint();

  /* ===========================================================
     3) BLUETOOTH CİHAZ SEÇİMİ

     navigator.bluetooth.requestDevice()

     kullanıcı tıklaması ile mümkün olduğunca yakın zamanda
     çağrılmalıdır.

     Bu nedenle:

     Bluetooth cihaz seçimi
        ↓
     axios/backend

     sırasını koruyoruz.

     Özellikle Bluefy / iOS için önemlidir.
  =========================================================== */

  if (
    bluetoothPrint &&
    !isBluetoothPrinterConnected()
  ) {
    try {
      await connectBluetoothPrinter();
    } catch (
      bluetoothError
    ) {
      console.error(
        "Bluetooth yazıcı bağlantısı kurulamadı:",
        bluetoothError
      );

      /*
       * Kullanıcı cihaz seçim ekranını kapattıysa
       * gereksiz hata popup'ı göstermiyoruz.
       */
      if (
        bluetoothError?.name ===
        "NotFoundError"
      ) {
        console.warn(
          "Bluetooth yazıcı seçimi iptal edildi."
        );
      } else {
        console.warn(
          bluetoothError?.message ||
            "Bluetooth yazıcı bağlantısı kurulamadı."
        );
      }

      /*
       * RETURN YOK.
       *
       * Bluetooth bağlantısı oluşmazsa aşağıda PC/browser
       * HTML print fallback denenebilir.
       */
    }
  }

  try {
    /* ===========================================================
       4) SEÇİLİ SATIRLARI BUL
    =========================================================== */

    const seciliSatirlar =
      rows.filter(
        (row) =>
          selectedRows.includes(
            row.id
          )
      );

    if (
      seciliSatirlar.length ===
      0
    ) {
      alert(
        "Seçilen işlemler listede bulunamadı."
      );

      return;
    }

    /* ===========================================================
       5) SEÇİLEN İŞLEMLERİN BAKİYE ETKİSİNİ HESAPLA

       Ekrandaki mevcut bakiye:
       SONRAKİ BAKİYE

       Seçilen işlemlerin etkisini çıkarınca:
       ÖNCEKİ BAKİYE
    =========================================================== */

    let etkGram = 0;
    let etkTl = 0;
    let etkUsd = 0;
    let etkEur = 0;

    seciliSatirlar.forEach(
      (row) => {
        const borc =
          Number(
            row?.borc || 0
          );

        const alacak =
          Number(
            row?.alacak || 0
          );

        /*
         * Mevcut hesaplama sistemindeki bakiye etkisi.
         */
        const net =
          borc -
          alacak;

        const tur =
          row?.islemTur ||
          "";

        /* =====================================================
           ALTIN KARŞILIĞI NAKİT

           NAKIT_ISLEM_GRAM_ALINDI
           NAKIT_ISLEM_GRAM_VERILDI

           Bu işlemler:

           - TL/USD/EUR bakiyesini değiştirmez.
           - GRAM bakiyesini değiştirir.
        ===================================================== */

        const isGramKarsiligiNakit =
          tur ===
            "NAKIT_ISLEM_GRAM_ALINDI" ||
          tur ===
            "NAKIT_ISLEM_GRAM_VERILDI";

        if (
          isGramKarsiligiNakit
        ) {
          etkGram +=
            net;

          return;
        }

        /* =====================================================
           BAĞLANTILI İŞLEMLER
        ===================================================== */

        const isBaglantiliIslem =
          tur ===
            "NAKIT_BAKIYE_GRAMA_CEVRILDI" ||
          tur ===
            "GRAM_BAKIYE_NAKITE_CEVRILDI";

        if (
          isBaglantiliIslem
        ) {
          const nakitMiktar =
            Number(
              row?.miktar ||
                0
            );

          const gramMiktar =
            Number(
              row?.hasGramToplam ||
                0
            );

          const nakitBirim =
            row?.birim ||
            "";

          /* ===================================================
             NAKİT -> GRAM

             İlk:
             Nakit bakiyesi azalır.

             Son:
             Gram bakiyesi artar.
          =================================================== */

          if (
            tur ===
            "NAKIT_BAKIYE_GRAMA_CEVRILDI"
          ) {
            if (
              nakitBirim ===
              "TL"
            ) {
              etkTl -=
                nakitMiktar;
            }

            if (
              nakitBirim ===
              "USD"
            ) {
              etkUsd -=
                nakitMiktar;
            }

            if (
              nakitBirim ===
              "EUR"
            ) {
              etkEur -=
                nakitMiktar;
            }

            etkGram +=
              gramMiktar;

            return;
          }

          /* ===================================================
             GRAM -> NAKİT

             İlk:
             Gram bakiyesi azalır.

             Son:
             Nakit bakiyesi artar.
          =================================================== */

          if (
            tur ===
            "GRAM_BAKIYE_NAKITE_CEVRILDI"
          ) {
            etkGram -=
              gramMiktar;

            if (
              nakitBirim ===
              "TL"
            ) {
              etkTl +=
                nakitMiktar;
            }

            if (
              nakitBirim ===
              "USD"
            ) {
              etkUsd +=
                nakitMiktar;
            }

            if (
              nakitBirim ===
              "EUR"
            ) {
              etkEur +=
                nakitMiktar;
            }

            return;
          }
        }

        /* =====================================================
           NORMAL ALTIN / GRAM İŞLEMLERİ
        ===================================================== */

        if (
          row?.birim ===
            "GRAM" ||
          tur ===
            "ALTIN_ALINDI" ||
          tur ===
            "ALTIN_VERILDI"
        ) {
          etkGram +=
            net;
        }

        /* =====================================================
           NORMAL TL
        ===================================================== */

        if (
          row?.birim ===
          "TL"
        ) {
          etkTl +=
            net;
        }

        /* =====================================================
           NORMAL USD
        ===================================================== */

        if (
          row?.birim ===
          "USD"
        ) {
          etkUsd +=
            net;
        }

        /* =====================================================
           NORMAL EUR
        ===================================================== */

        if (
          row?.birim ===
          "EUR"
        ) {
          etkEur +=
            net;
        }
      }
    );

    /* ===========================================================
       6) SONRAKİ BAKİYE

       Sayfada gösterilen güncel bakiyeler.
    =========================================================== */

    const son = {
      gram:
        Number(
          bakiyeGram ||
            0
        ),

      tl:
        Number(
          bakiyeTL ||
            0
        ),

      usd:
        Number(
          bakiyeUSD ||
            0
        ),

      eur:
        Number(
          bakiyeEUR ||
            0
        ),
    };

    /* ===========================================================
       7) ÖNCEKİ BAKİYE

       Önceki =
       Sonraki -
       seçili işlemlerin toplam bakiye etkisi
    =========================================================== */

    const onceki = {
      gram:
        son.gram -
        etkGram,

      tl:
        son.tl -
        etkTl,

      usd:
        son.usd -
        etkUsd,

      eur:
        son.eur -
        etkEur,
    };

    /* ===========================================================
       8) FİŞ TARİHİ

       Birden fazla işlem seçilebildiği için seçilenler
       içerisindeki EN ESKİ işlem tarihini fiş tarihi olarak
       kullanıyoruz.
    =========================================================== */

    let tarihStr =
      "";

    if (
      seciliSatirlar.length >
      0
    ) {
      const sorted = [
        ...seciliSatirlar,
      ].sort(
        (
          a,
          b
        ) => {
          const tarihA =
            a?.tarih
              ? new Date(
                  a.tarih
                ).getTime()
              : 0;

          const tarihB =
            b?.tarih
              ? new Date(
                  b.tarih
                ).getTime()
              : 0;

          return (
            tarihA -
            tarihB
          );
        }
      );

      const first =
        sorted[0];

      if (
        first?.tarih
      ) {
        const tarih =
          new Date(
            first.tarih
          );

        if (
          !Number.isNaN(
            tarih.getTime()
          )
        ) {
          const pad =
            (
              value
            ) =>
              value <
              10
                ? `0${value}`
                : `${value}`;

          tarihStr =
            `${pad(
              tarih.getDate()
            )}.` +
            `${pad(
              tarih.getMonth() +
                1
            )}.` +
            `${tarih.getFullYear()} ` +
            `${pad(
              tarih.getHours()
            )}:` +
            `${pad(
              tarih.getMinutes()
            )}`;
        }
      }
    }

    /* ===========================================================
       9) BACKEND'DEN FİŞ VERİLERİNİ AL

       POST /api/fis/olustur

       selectedRows:
       [
         1,
         2,
         ...
       ]
    =========================================================== */

    const response =
      await axiosInstance.post(
        "/fis/olustur",
        selectedRows
      );

    const {
      altin = [],
      ziynet = [],
      nakit = [],
      gramKarNakit = [],
      hesapAdi = "",
      firmaAdi = "",
      ziynetBakiyeler =
        null,
    } =
      response?.data ||
      {};

    /* ===========================================================
       10) BAĞLANTILI İŞLEM KONTROLÜ
    =========================================================== */

    const isBaglantiliFisIslemi =
      (
        islemTur
      ) =>
        islemTur ===
          "NAKIT_BAKIYE_GRAMA_CEVRILDI" ||
        islemTur ===
          "GRAM_BAKIYE_NAKITE_CEVRILDI";

    /* ===========================================================
       11) NAKİT LİSTESİNİ TEMİZLE

       Backend bağlantılı işlemi bazı durumlarda nakit listesine
       de ekleyebildiği için bağlantılı kayıtları buradan
       çıkarıyoruz.

       Böylece aynı kayıt:

       NAKİT İŞLEMLERİ
       +
       BAĞLANTILI İŞLEMLER

       şeklinde iki kez basılmaz.
    =========================================================== */

    const temizNakit =
      Array.isArray(
        nakit
      )
        ? nakit.filter(
            (
              row
            ) =>
              !isBaglantiliFisIslemi(
                row?.islemTur
              )
          )
        : [];

    /* ===========================================================
       12) ALTIN KARŞILIĞI NAKİT LİSTESİ

       Tedbir amaçlı:
       bağlantılı işlem buraya düşmüşse burada da çıkarılır.
    =========================================================== */

    const temizGramKarNakit =
      Array.isArray(
        gramKarNakit
      )
        ? gramKarNakit.filter(
            (
              row
            ) =>
              !isBaglantiliFisIslemi(
                row?.islemTur
              )
          )
        : [];

    /* ===========================================================
       13) BAĞLANTILI İŞLEM FİŞ MODELİ

       NAKİT -> GRAM

       İlk Miktar = Nakit
       İlk Birim  = TL / USD / EUR

       Son Miktar = Gram
       Son Birim  = GRAM


       GRAM -> NAKİT

       İlk Miktar = Gram
       İlk Birim  = GRAM

       Son Miktar = Nakit
       Son Birim  = TL / USD / EUR
    =========================================================== */

    const baglantili =
      seciliSatirlar
        .filter(
          (
            row
          ) =>
            isBaglantiliFisIslemi(
              row?.islemTur
            )
        )
        .map(
          (
            row
          ) => {
            const nakitMiktar =
              Number(
                row?.miktar ||
                  0
              );

            const gramMiktar =
              Number(
                row?.hasGramToplam ||
                  0
              );

            const nakitBirim =
              row?.birim ||
              "";

            /* =================================================
               NAKİT -> GRAM
            ================================================= */

            if (
              row?.islemTur ===
              "NAKIT_BAKIYE_GRAMA_CEVRILDI"
            ) {
              return {
                islemTur:
                  row.islemTur,

                ilkMiktar:
                  nakitMiktar,

                ilkBirim:
                  nakitBirim,

                sonMiktar:
                  gramMiktar,

                sonBirim:
                  "GRAM",
              };
            }

            /* =================================================
               GRAM -> NAKİT
            ================================================= */

            return {
              islemTur:
                row.islemTur,

              ilkMiktar:
                gramMiktar,

              ilkBirim:
                "GRAM",

              sonMiktar:
                nakitMiktar,

              sonBirim:
                nakitBirim,
            };
          }
        );

    /* ===========================================================
       14) ORTAK FİŞ MODELİ

       PC ve Bluetooth aynı işlem verilerini kullanır.

       Fark sadece çıktı motorundadır:

       PC:
       HTML

       Bluetooth:
       ESC/POS text
    =========================================================== */

    const fis = {
      /* =======================================================
         ALTIN
      ======================================================= */

      altin:
        Array.isArray(
          altin
        )
          ? altin
          : [],

      /* =======================================================
         ZİYNET
      ======================================================= */

      ziynet:
        Array.isArray(
          ziynet
        )
          ? ziynet
          : [],

      /* =======================================================
         NAKİT
      ======================================================= */

      nakit:
        temizNakit,

      /* =======================================================
         ALTIN KARŞILIĞI NAKİT
      ======================================================= */

      gramKarNakit:
        temizGramKarNakit,

      /* =======================================================
         BAĞLANTILI
      ======================================================= */

      baglantili:
        baglantili,
    };

    /* ===========================================================
       15) HTML FİŞ

       Bunu PC baskısı ve Bluetooth başarısız olursa browser
       fallback için yine hazırlıyoruz.

       Bluetooth artık bu HTML'i rastera ÇEVİRMİYOR.
    =========================================================== */

    const html =
      buildFisHTML(
        fis,
        onceki,
        son,
        tarihStr,
        hesapAdi,
        firmaAdi,
        ziynetBakiyeler
      );

    /* ===========================================================
       16) MOBİL + BLUETOOTH

       KRİTİK YENİ YAPI:

       ESKİ:

       printBluetoothHtml(html)
          ↓
       SVG
          ↓
       Canvas
          ↓
       Raster
          ↓
       BLE


       YENİ:

       printBluetoothFis(...)
          ↓
       buildEscPosFis()
          ↓
       ESC/POS TEXT
          ↓
       BLE


       Bluefy için özel API YOKTUR.

       Bluefy'nin sunduğu navigator.bluetooth kullanılır.
    =========================================================== */

    if (
      bluetoothPrint &&
      isBluetoothPrinterConnected()
    ) {
      try {
        await printBluetoothFis({
          fis,
          onceki,
          son,
          tarih:
            tarihStr,
          hesapAdi,
          firmaAdi,
          ziynetBakiyeler,
        });

        /* =====================================================
           BLUETOOTH BAŞARILI

           Browser print ekranı açılmaz.
        ===================================================== */

        console.log(
          "Bluetooth ESC/POS fişi başarıyla gönderildi."
        );

        return;
      } catch (
        bluetoothPrintError
      ) {
        /* =====================================================
           BLUETOOTH BASKI HATASI

           Artık gerçek hata mesajını kullanıcıya gösteriyoruz.

           Önceki sürümde sadece:
           "Bluetooth yazdırma başarısız"

           yazdığı için gerçek sebebi göremiyorduk.
        ===================================================== */

        console.error(
          "Bluetooth ESC/POS yazdırma hatası:",
          bluetoothPrintError
        );

        const errorMessage =
          bluetoothPrintError
            ?.message ||
          bluetoothPrintError
            ?.name ||
          String(
            bluetoothPrintError ||
              ""
          ) ||
          "Bilinmeyen Bluetooth hatası.";

        alert(
          "Bluetooth yazdırma başarısız oldu.\n\n" +
            `Hata: ${errorMessage}\n\n` +
            "Standart yazdırma ekranı açılacak."
        );

        /*
         * RETURN YOK.
         *
         * Browser print fallback aşağıda çalışır.
         */
      }
    }

    /* ===========================================================
       17) STANDART HTML / BROWSER PRINT

       Bu bölüm:

       - PC / Masaüstünde normal baskı yöntemi.
       - Web Bluetooth desteklenmiyorsa.
       - Bluetooth bağlantısı kurulamadıysa.
       - Bluetooth baskısı hata verdiyse.

       kullanılır.
    =========================================================== */

    printHtmlFallback(
      html
    );
  } catch (
    error
  ) {
    /* ===========================================================
       18) GENEL HATA
    =========================================================== */

    console.error(
      "Fiş oluşturma/yazdırma hatası:",
      error
    );

    /* ===========================================================
       BACKEND HATA DETAYI
    =========================================================== */

    if (
      error?.response
    ) {
      console.error(
        "Backend status:",
        error.response
          .status
      );

      console.error(
        "Backend response:",
        error.response
          .data
      );
    }

    /* ===========================================================
       KULLANICI MESAJI
    =========================================================== */

    const backendMessage =
      error?.response
        ?.data
        ?.message;

    const backendData =
      error?.response
        ?.data;

    let message =
      "Fiş oluşturulurken bir hata oluştu.";

    if (
      backendMessage
    ) {
      message =
        backendMessage;
    } else if (
      typeof backendData ===
      "string"
    ) {
      message =
        backendData;
    } else if (
      error?.message
    ) {
      message =
        error.message;
    }

    alert(
      message
    );
  }
};